import styled from 'styled-components';

export const PaginationContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	margin-top: 40px;
`;

export const ScrollToTopButton = styled.div`
	background-color: ${({ theme }) => theme.colors.control.dark};
	border-radius: 50%;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 42px;
	height: 42px;
	transition: background-color 0.2s;
	align-self: flex-end;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}
	
	&:hover {
		background-color: ${({ theme }) => theme.colors.control.darkHover};
	}
`;

export const EmptyState = styled.div`
	text-align: center;
	color: ${({ theme }) => theme.colors.text.title};
	margin: 40px 0;
`;

export const EmptyTitle = styled.div`
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 8px;
`;

export const EmptyDescription = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.colors.text.subtitle};
	line-height: 1.5;
`; 